var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-1"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var _vm$product, _vm$product2;
        var on = _ref.on;
        return [_c('div', _vm._g({}, _vm.tooltip ? on : null), [_c('stroke', {
          staticClass: "mr-1 mb-1",
          attrs: {
            "strike": (((_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : _vm$product.archived) || _vm.strike) && _vm.enableStrike
          }
        }, [_c('span', {
          staticClass: "mr-1 mb-0 mt-sm-0"
        }, [_c('div', {
          staticClass: "align-center"
        }, [_vm.code && !_vm.inlineCode ? _c('div', {
          staticClass: "mb-1 mr-2"
        }, [_vm.type && _vm.product && _vm.canLinkToType ? _c('ScopedRouteLink', {
          attrs: {
            "to": {
              name: _vm.type,
              params: {
                product_id: _vm.product.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.codeValue) + " ")]) : [_vm._v(" " + _vm._s(_vm.codeValue) + " ")]], 2) : _vm._e(), _c('div', {
          staticClass: "product-name-title-row d-flex align-center flex-wrap"
        }, [_c('span', {
          staticClass: "font-weight-bold product-name-title-text"
        }, [_vm.displayCode && _vm.inlineCode && _vm.codeValue ? [_vm.code && _vm.inlineCode && ((_vm$product2 = _vm.product) === null || _vm$product2 === void 0 ? void 0 : _vm$product2.id) != null && _vm.type && _vm.canLinkToType ? _c('ScopedRouteLink', {
          attrs: {
            "to": {
              name: _vm.type,
              params: {
                product_id: _vm.product.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.codeValue) + " ")]) : [_vm._v(" " + _vm._s(_vm.codeValue) + " ")], _vm._v(" - ")] : _vm._e(), _vm.label ? [_vm._v(_vm._s(_vm.label))] : _vm.product ? [_vm._v(_vm._s(_vm.product.name))] : _c('i', {
          staticClass: "warning--text"
        }, [_vm._v(_vm._s(_vm.$translate('noName')))]), _vm.displayManufacturer && _vm.manufacturerValue ? [_c('i', {
          staticClass: "grey--text text--darken-2 text-justify"
        }, [_vm._v(" " + _vm._s(_vm.isMobile ? "" : "-") + " " + _vm._s(_vm.manufacturerValue))])] : _vm._e()], 2), _vm.chips && _vm.chips.length ? _c('div', {
          staticClass: "product-name-chips-nowrap d-flex flex-nowrap align-center"
        }, _vm._l(_vm.chips, function (chip, idx) {
          return _c('v-chip', {
            key: idx,
            staticClass: "product-name-chip",
            attrs: {
              "x-small": "",
              "color": chip.color || 'default',
              "text-color": chip.textColor || 'white',
              "outlined": !!chip.outlined
            }
          }, [chip.icon ? _c('v-icon', {
            attrs: {
              "left": "",
              "x-small": ""
            }
          }, [_vm._v(" " + _vm._s(chip.icon) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(chip.label) + " ")], 1);
        }), 1) : _vm._e()])]), _vm.descriptionValue && _vm.displayDescription || _vm.formatLabel ? _c('div', {
          staticClass: "mt-0 wrap product-name-meta-row"
        }, [_vm.descriptionValue && _vm.displayDescription ? [_vm._v(" " + _vm._s(_vm.descriptionValue) + " ")] : _vm._e(), _vm.formatLabel && _vm.descriptionValue && _vm.displayDescription ? [_vm._v(" " + _vm._s(" - ") + " ")] : _vm._e(), _vm.formatLabel ? _c('span', {
          staticClass: "text-caption grey--text text--darken-1 product-name-format-label"
        }, [_vm._v(" " + _vm._s(_vm.formatLabel) + " ")]) : _vm._e()], 2) : _vm._e()])])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltip))])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }